import axios from 'axios'

const AuthService = {
  async signIn (params = {}) {
    return axios.post('auth/login', params)
  },

  async getCurrentUser (params = {}) {
    return axios.get('auth/me', { params })
  },

  async changePassword (params = {}) {
    return axios.post('auth/password', params)
  },

  async logout () {
    return axios.post('auth/logout')
  }
}

export default AuthService
